import React, { ReactElement } from 'react';
import { SearchTab } from './SearchTab';
import { TabsList } from './styled';
import { SearchTabsProps, TabData, TabVariantEnum } from './types';

export const SearchTabs: React.FC<SearchTabsProps> = ({
  children,
  switchTab,
  currentTabId,
  titles,
  disabled,
  variant = TabVariantEnum.Grey,
  height = 48
}) => {
  const tabTitles = titles || React.Children.toArray(children);

  return (
    <TabsList height={height}>
      {tabTitles?.map((tab, i) => {
        const tabData = ((tab as ReactElement).props || tab) as TabData;

        return (
          <SearchTab
            key={i}
            name={tabData.name}
            text={tabData.label}
            currentTabId={currentTabId}
            switchTab={switchTab}
            tabId={i}
            itemsCount={tabData.itemsCount}
            disabled={disabled}
            stat={tabData.stat}
            isSelected={tabData.isSelected}
            onClick={tabData.onClick}
            variant={variant}
          />
        );
      })}
    </TabsList>
  );
};
